enum TipoEntidadeIntegracao {
    Servico = 1,
    Cliente = 2,
    Fornecedor = 3,
}
export default TipoEntidadeIntegracao;
